import React from "react"
import Loader from "react-loader-spinner"
import Button from "../../atoms/button/button"
import "./upload-image-change-birthdate.scss"

const UploadImage = ({
  images,
  errorImages,
  handleChangeImg,
  handeDelateImage,
  closeModal,
  onClickNext,
  isLoading,
}) => {
  return (
    <div className="f-upload-image">
      <h3 className="f-modal__title">
        Necesitamos dos fotos de tu documento de identidad, una por cada lado{" "}
      </h3>
      <h2 className="f-modal__subtitle">Sube tus dos fotos</h2>
      <p className="f-modal__description  ">
        Tu foto debe ser clara, a color, en formato .JPG, .JPEG O  .PNG y con un tamaño
        máximo de 5 Mb.
      </p>

      {images.length < 2 && (
        <div className="f-input-img-container">
          <div className="f-text-input-position">
            <div className="f-rotate-container">
              <span className="f-icon icon-exit f-exit-icon" />
            </div>

            <label className="f-top-label">
              Arrastra la imagen que quieras o
            </label>
            <label className="f-bottom-label">Explora en tu dispositivo</label>
          </div>

          <input
            className="f-input-file-box"
            type="file"
            name="f-profile-picture"
            accept=".jpg, .png, .jpeg"
            onChange={e => {
              handleChangeImg(e.target.files[0])
            }}
          />
        </div>
      )}

      {errorImages && <p className="f-img-label-error">{errorImages}</p>}

      {isLoading && (
        <div className="f-loader-container">
          <Loader type="TailSpin" color="#FF409B" height={50} width={50} />
        </div>
      )}

      {!isLoading && (
        <div className="f-preview-container">
          {images.map((file, index) => (
            <div className="f-preview-document-container">
              <div
                className="f-preview-document"
                key={`document-${index}-${file.name}`}
              >
                <button
                  className="icon2-close"
                  onClick={() => {
                    handeDelateImage(index)
                  }}
                />
                <img
                  src={URL.createObjectURL(file)}
                  className="f-preview-document__img"
                  alt={file.name}
                />
              </div>
              <p className="f-preview-document__description">
                Vista previa parte {index + 1}
              </p>
            </div>
          ))}
        </div>
      )}

      <div className="f-buttons-container">
        <Button
          title="Cancelar"
          className="secondary-pink"
          onClick={closeModal}
        />
        <Button
          title="Siguiente"
          className={`primary-pink ${images.length < 2 ? "disabled" : ""}`}
          onClick={onClickNext}
        />
      </div>
    </div>
  )
}

export default UploadImage
